// Form validation helper functions for reuse across multiple forms

// Email validation regex pattern
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Validate email format
export function validateEmail(email: string): boolean {
  if (!email.trim()) return false;
  return EMAIL_REGEX.test(email);
}

// Validate required field (non-empty string)
export function validateRequired(value: string): boolean {
  return value.trim().length > 0;
}

// Validate max length
export function validateMaxLength(value: string, maxLength: number): boolean {
  return value.length <= maxLength;
}

// Validate checkbox (boolean must be true)
export function validateCheckbox(checked: boolean): boolean {
  return checked === true;
}

// Validate CAPTCHA token exists
export function validateCaptchaToken(token: string | null | undefined): boolean {
  return !!token && token.trim().length > 0;
}

// Validate a list of required fields
export function validateRequiredFields(fields: Record<string, string>): boolean {
  return Object.values(fields).every((value) => validateRequired(value));
}

// Export regex for custom use if needed
export { EMAIL_REGEX };
